import {
    FETCH_SELLERS,
    FETCH_SELLER,
    EDIT_SELLER,
    FETCH_INTEGRADORES,
    FETCH_FACTURACIONES,
    FETCH_SELLERS_FILTER,
    FETCH_LIQUIDACIONES_LISTA_SELLERS,
    SET_FILTRO_SELLER,
    FETCH_PROVEEDORES_FILTER,
    LOADING_SELLERS,
    RESET_SELLERS,
    UPDATE_SELLERS_LIST,
    FETCH_PROVINCIAS_LOCALIDADES,
    CLEAR_LOCALIDAD_PROVINCIA,
    FETCH_LOGISTICA_PROPIA,
    SET_LOGISTICA_PROPIA,
    SET_LOGISTICA_DIRTY,
    SET_LOGISTICA_CACHE,
    CLEAR_LOGISTICA_FOR_SELLER
} from '../actions/types';

const initialState = {
    sellers: [],
    seller: {},
    integradores: [],
    facturaciones: [],
    filteredSellers: [],
    lista_sellers_liquidaciones: [],
    filtro: {},
    filteredProveedores: [],
    loadingSellers: false,
    provinciasLocalidades: [],
    logisticaPropia: undefined,
    logisticaCache: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_FILTRO_SELLER:
            return {
                ...state,
                filtro: action.payload
            }
        case FETCH_SELLERS:
            return {
                ...state,
                sellers: action.payload
            }
        case FETCH_SELLER:
        case EDIT_SELLER:
            return {
                ...state,
                seller: action.payload
            }
        case FETCH_INTEGRADORES:
            return {
                ...state,
                integradores: action.payload
            }
        case FETCH_FACTURACIONES:
            return {
                ...state,
                facturaciones: action.payload
            }
        case FETCH_SELLERS_FILTER:
            return {
                ...state,
                filteredSellers: action.payload
            }
        case FETCH_PROVEEDORES_FILTER:
            return {
                ...state,
                filteredProveedores: action.payload
            }
        case FETCH_LIQUIDACIONES_LISTA_SELLERS:
            return {
                ...state,
                lista_sellers_liquidaciones: action.payload
            }
        case LOADING_SELLERS:
            return {
                ...state,
                loadingSellers: action.payload
            }
        case RESET_SELLERS:
            return {
                ...state,
                sellers: []
            }
        case UPDATE_SELLERS_LIST:
            return {
                ...state,
                sellers: action.payload
            }
        case FETCH_PROVINCIAS_LOCALIDADES:
            return {
                ...state,
                provinciasLocalidades: action.payload
            }
        case CLEAR_LOCALIDAD_PROVINCIA:
            return {
                ...state,
                provinciasLocalidades: {}
            };
        case FETCH_LOGISTICA_PROPIA:
            return {
                ...state,
                logisticaPropia: action.payload
            }
        case SET_LOGISTICA_PROPIA:
            return {
                ...state,
                logisticaPropia: action.payload
            };
        case SET_LOGISTICA_DIRTY: {
            const { idSeller, dirty } = action.payload;
            const prev = state.logisticaCache?.[idSeller] || {};
            return {
                ...state,
                logisticaCache: {
                    ...state.logisticaCache,
                    [idSeller]: { ...prev, dirty }
                }
            };
        }
        case SET_LOGISTICA_CACHE: {
            const { idSeller, data, dirty = false } = action.payload;
            return {
                ...state,
                logisticaCache: {
                    ...state.logisticaCache,
                    [idSeller]: { data, dirty, fetchedAt: Date.now() }
                }
            };
        }
        case CLEAR_LOGISTICA_FOR_SELLER: {
            const { idSeller } = action.payload;
            const nextCache = { ...(state.logisticaCache || {}) };
            if (idSeller != null) delete nextCache[idSeller];
            return {
                ...state,
                logisticaPropia: undefined,
                logisticaCache: nextCache,
            };
        }
        default: return state
    }
}